import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b26549a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-icon" }
const _hoisted_2 = ["src"]

import { PropType } from 'vue';
import { InventoryItemOption } from '../../ecs/loadout/main';

import { IconMap } from './Icon';

export default /*#__PURE__*/_defineComponent({
  __name: 'InventoryIconComponent',
  props: {
  item: {
    type: Object as PropType<InventoryItemOption>,
    required: true
  }
},
  setup(__props) {

const prop = __props



const iconImage = IconMap[prop.item.icon];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge", {
      disabled: prop.item.disabled.value,
      selected: prop.item.selected.value,
      alert: prop.item.alert.value
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(iconImage))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(iconImage)
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})